export enum UserIconType {
  SINGLE = 'single-user-icon',
  MULTI = 'multi-users-icon',
  TWO = 'two-users-icon',
}
